export default __webpack_public_path__ + "static/media/logo.bc6b04f3.svg";